export default "__VITE_ASSET__9f225656__"